export enum AddressStatus {
  Active = "Active",
  Inactive = "Inactive",
}
